"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { Home, LayoutGrid, Heart, User } from "lucide-react";
import { motion } from "framer-motion";

const tabs = [
  { to: "/", icon: Home, label: "Home" },
  { to: "/categories", icon: LayoutGrid, label: "Categories" },
  { to: "/favourites", icon: Heart, label: "Favourites" },
  { to: "/account", icon: User, label: "Account" },
];

const BottomNav = () => {
  const pathname = usePathname();

  if (pathname === "/cart") return null;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-card/95 backdrop-blur-md border-t border-border shadow-[0_-4px_20px_rgba(0,0,0,0.06)] md:hidden">
      <div className="flex items-center justify-around py-1 px-2">
        {tabs.map(({ to, icon: Icon, label }) => {
          const isActive = to === "/" ? pathname === "/" : pathname.startsWith(to);
          return (
            <Link
              key={to}
              href={to}
              className="flex flex-col items-center gap-0.5 px-3 py-1 relative"
            >
              {isActive && (
                <motion.div
                  layoutId="bottomNavIndicator"
                  className="absolute -top-1 w-8 h-0.5 bg-primary rounded-full"
                  transition={{ type: "spring", stiffness: 400, damping: 30 }}
                />
              )}
              <Icon
                className={`w-[18px] h-[18px] transition-colors duration-200 ${isActive ? "text-primary" : "text-muted-foreground"
                  }`}
                fill={isActive ? "currentColor" : "none"}
              />
              <span
                className={`text-[10px] transition-colors duration-200 ${isActive ? "text-primary font-semibold" : "text-muted-foreground font-medium"
                  }`}
              >
                {label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
